import { useCallback, useEffect, useState } from 'react';

import { AvailableFokParameterChoiceViewModel } from '@fora-monorepo/employer-my-pages-common/types';
import { ThunkRequestHook } from '@fora-monorepo/webapp-types';

import { useAppDispatch } from '../../hooks';
import { geAvailableFokParameterChoices } from '../employmentThunks';

export const useFetchParameterChoices = (
  policyNumber: string
): ThunkRequestHook<AvailableFokParameterChoiceViewModel[] | null> => {
  const [parameterChoices, setParameterChoices] = useState<AvailableFokParameterChoiceViewModel[] | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(true);
  const [shouldRetry, setShouldRetry] = useState(true);

  const dispatch = useAppDispatch();

  const fetchParameterChoices = useCallback(async () => {
    setIsLoading(true);
    setHasError(false);
    dispatch(geAvailableFokParameterChoices(policyNumber)).then(result => {
      if (geAvailableFokParameterChoices.fulfilled.match(result)) {
        setParameterChoices(result.payload);
      } else if (geAvailableFokParameterChoices.rejected.match(result)) {
        setHasError(true);
      }
      setIsLoading(false);
      setShouldRetry(false);
    });
  }, [dispatch, policyNumber]);

  useEffect(() => {
    if (!parameterChoices || shouldRetry) {
      fetchParameterChoices();
    }
  }, [fetchParameterChoices, parameterChoices, policyNumber, shouldRetry]);

  return {
    data: parameterChoices,
    isLoading,
    hasError,
    retryRequest: () => {
      setShouldRetry(true);
    },
  };
};
